import { faCalendarCheck, faCircleCheck } from "@fortawesome/pro-solid-svg-icons"
import { Grid, TextField, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { Box } from "@mui/system"
import { DateTimePicker } from "@mui/x-date-pickers"
import ClpButton from "components/Button"
import moment from "moment"
import EmailBoxTypography from "pages/issuereports/pages/workorders/components/EmailBox/EmailBoxTypography"
import { Fragment } from "react"
import { StyledWhiteBox } from "shared/styled/General"
import {
  StyledBlueIcon,
  StyledBlueText,
  StyledDateTypography,
  StyledGreenIcon,
  StyledGreenText,
  StyledRedIcon,
  StyledRedText,
  StyledWrapBox
} from "./ExternalStatusBox.styled"
import ExternalOrderBox from "../ExternalOrderBox"
import { statusButtonColor, statusButtonText, statusSubText } from "../helpers"
import { fontAwesomeOldXlStyle } from "components/icons/fontAwesomeStyles"

const ExternalStatusBox = ({
  values,
  handleChange,
  handleBlur,
  touched,
  buttonFeedbackResult,
  errors,
  uploadedFiles,
  status,
  setFieldValue,
  t
}) => {
  const theme = useTheme()

  const getStatus = (status) => {
    let statusText
    let statusIcon
    let statusContent
    let themeBackgroundColor

    switch (status) {
      case 2:
        statusIcon = null
        statusText = (
          <StyledBlueText variant="h2">
            {t("issureports.book_an_appointment_for_the_work", "Book an appointment for the work")}
          </StyledBlueText>
        )
        statusContent = (
          <Box>
            <EmailBoxTypography
              text={t(
                "issureports.choose_the_date_you_want",
                "Choose the date you want us to drop off the vehicle at your place."
              )}
              variant="bodyMedium"
              pb={2}
            />
            <StyledWhiteBox sx={{ minWidth: 200 }} mt={1}>
              <DateTimePicker
                value={values.plannedDate}
                onChange={(value) => {
                  setFieldValue("plannedDate", value)
                }}
                slotProps={{ textField: { fullWidth: true } }}
                inputFormat="YYYY-MM-DD HH:mm"
                renderInput={(params) => (
                  <TextField
                    variant="outlined"
                    error={touched.plannedDate && errors.plannedDate ? true : false}
                    fullWidth
                    {...params}
                  />
                )}
              />
            </StyledWhiteBox>
            {touched.plannedDate && errors.plannedDate ? (
              <StyledDateTypography>{errors.plannedDate}</StyledDateTypography>
            ) : null}
          </Box>
        )
        themeBackgroundColor = theme.palette.primary["light"]
        break
      case 3:
        statusIcon = <StyledBlueIcon icon={faCalendarCheck} style={fontAwesomeOldXlStyle} />
        statusText = <StyledBlueText variant="h2">{t("global.booked", "Booked")}</StyledBlueText>
        statusContent = (
          <Box>
            <EmailBoxTypography text={t("global.planned_action", "Planned action")} variant="bodySmall" />
            <EmailBoxTypography
              text={
                moment(values.plannedDate).isValid()
                  ? moment.utc(values.plannedDate).local().format("YYYY-MM-DD HH:mm")
                  : "-"
              }
              variant="h6"
            />
          </Box>
        )
        themeBackgroundColor = theme.palette.primary["light"]
        break
      case 4:
        statusIcon = <StyledGreenIcon icon={faCircleCheck} style={fontAwesomeOldXlStyle} />
        statusText = <StyledGreenText variant="h2">{t("global.fixed", "Fixed")}</StyledGreenText>
        statusContent = (
          <Box>
            <EmailBoxTypography text={t("global.fixed", "Fixed")} variant="bodySmall" />
            <EmailBoxTypography
              text={
                moment(values.resolvedDate).isValid()
                  ? moment.utc(values.resolvedDate).local().format("YYYY-MM-DD HH:mm")
                  : "-"
              }
              variant="h6"
            />
          </Box>
        )
        themeBackgroundColor = theme.palette.success["light"]
        break
      case 5:
        statusIcon = <StyledGreenIcon icon={faCircleCheck} style={fontAwesomeOldXlStyle} />
        statusText = <StyledGreenText variant="h2">{t("global.completed", "Completed")}</StyledGreenText>
        statusContent = (
          <Box>
            <EmailBoxTypography text={t("global.fixed", "Fixed")} variant="bodySmall" />
            <EmailBoxTypography
              text={
                moment(values.resolvedDate).isValid()
                  ? moment.utc(values.resolvedDate).local().format("YYYY-MM-DD HH:mm")
                  : "-"
              }
              variant="h6"
            />
          </Box>
        )
        themeBackgroundColor = theme.palette.success["light"]
        break
      case 6:
        statusIcon = <StyledRedIcon icon={faCircleCheck} style={fontAwesomeOldXlStyle} />
        statusText = <StyledRedText variant="h2">{t("global.cancelled", "Cancelled")}</StyledRedText>
        statusContent = null
        themeBackgroundColor = theme.palette.error["light"]
        break
      default:
        statusIcon = null
        statusText = (
          <StyledBlueText variant="h2">
            {t("issureports.book_an_appointment_for_the_work", "Book an appointment for the work")}
          </StyledBlueText>
        )
        statusContent = <Box></Box>
        themeBackgroundColor = theme.palette.primary["light"]
        break
    }

    return { statusIcon, statusText, statusContent, themeBackgroundColor }
  }
  const { statusIcon, statusText, statusContent, themeBackgroundColor } = getStatus(status)
  return (
    <Grid item xs={12} md={12} lg={4} direction="row" justifyContent="space-between">
      <StyledWrapBox themeData={themeBackgroundColor}>
        <Box p={3}>
          <Box mb={2} display="flex" alignItems="center">
            {statusIcon}
            {statusText}
          </Box>
          {statusContent}

          {status < 4 && (
            <Fragment>
              <Box mt={3} mb={2}>
                <ClpButton
                  color={statusButtonColor(status)}
                  result={buttonFeedbackResult}
                  variant="contained"
                  type="submit">
                  {statusButtonText(status, t)}
                </ClpButton>
              </Box>
            </Fragment>
          )}
          <Typography variant="bodySmall">{statusSubText(values, t)}</Typography>
        </Box>
      </StyledWrapBox>
      <ExternalOrderBox values={values} t={t} />
    </Grid>
  )
}

export default ExternalStatusBox
